import {createSelector} from '@reduxjs/toolkit'

import {isEmpty} from '@shared/helpers/lang'

import {RootState} from '../interfaces'
import {getInitialState} from '../utils'

export const expenseDetailsSelector = (state: RootState) => state.expenseDetails ?? getInitialState()

export const priceSelector = createSelector(expenseDetailsSelector, ({price, priceToBePaid, items}) => {
    const itemCount = items.length
    const totalPrice = items.reduce<number>((sum, item) => sum + item.price * item.quantity, 0)
    const discountedPrice = items.reduce<number>((sum, item) => sum + (item.price - item.discount) * item.quantity, 0)

    return {
        price,
        itemCount,
        totalPrice,
        priceToBePaid: itemCount > 0 ? discountedPrice : priceToBePaid,
    }
})

/** 결제 금액 */
export const orderAmountSelector = createSelector(
    expenseDetailsSelector,
    ({priceToBePaid, price}) => priceToBePaid ?? price,
)

/** 휴대폰 결제의 결제 예상 값 */
export const mobilePaymentPriceSelector = createSelector(expenseDetailsSelector, ({items, price: amt}) => {
    if (isEmpty(items)) {
        return amt
    }

    return items.reduce((prev, {price}) => prev + price, 0)
})
